<div
    class="shift-container shadowed float-behavior hover click content card"
    (click)="selectShift()"
    [ngClass]="{ active: shift.active }"
>
    <div class="card-body">
        <h5 class="title" *ngIf="shift?.shiftId !== -1">
            {{ "shift" | lang : shift.name }}
        </h5>
        <h5 class="title" *ngIf="shift?.shiftId === -1">{{ shift.name }}</h5>
        <div class="detail row" *ngIf="showProduction">
            <div
                class="d-flex align-items-end col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3"
            >
                <div
                    class="mb-3 content flex-col"
                    *ngIf="machineContext === 'lhd' && canVisualize"
                >
                    <div class="grade value">
                        {{ shift.grade !== null ? shift.grade : "-" }}
                    </div>
                    <div class="grade name">{{ "grade-average" | lang }}</div>
                </div>
            </div>
            <div
                id="values"
                class="col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 card-detail"
            >
                <div
                    class="quantity-content content flex-col"
                    *ngIf="unit && quantity"
                >
                    <div class="value">
                        {{ shift.totalMeasure }}
                    </div>
                    <div class="name">{{ unit | lang }}</div>
                </div>
                <div
                    class="unit-content content flex-col"
                    *ngIf="unit && quantity"
                >
                    <div class="value">
                        {{ shift.countMeasure | number : ".0-2" | noComma }}
                    </div>
                    <div class="name">{{ quantity | lang }}</div>
                </div>
                <div
                    class="quantity-unique content flex-col"
                    *ngIf="quantity && !unit"
                >
                    <div class="value">
                        {{ shift.countMeasure }}
                    </div>
                    <div class="name">{{ quantity | lang }}</div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="shift-name">
                <div class="icon">
                    <em class="material-icons">{{
                        shift.active ? "chevron_right" : "query_stats"
                    }}</em>
                </div>
                <div class="shift-content">
                    <span *ngIf="shift.active">{{ "look" | lang }}</span>
                    <span *ngIf="!shift.active">{{ "look" | lang }}</span>

                    <!-- <span *ngIf="shift?.shiftId !== -1"
                    >&nbsp;{{ "detail_shift" | lang: shift.name }}</span
                > -->
                    <!-- <span *ngIf="shift?.shiftId === -1"
                    >&nbsp;{{ shift.name }}</span
                > -->
                </div>
            </div>
        </div>
    </div>
</div>
